<template>
  <!-- 详情，列表模板 -->
  <div>
    <!-- 导航条 -->
    <!-- <template v-if="isShow">
      <div class="mobilenav">

        <div>
          <router-view></router-view>
        </div>

        <MFooter></MFooter>
      </div>
    </template>-->
    <template>
      <div class="nav_header">
        <div class="header_txt">
          <el-row :gutter="20">
            <el-col :span="8" class="nav-left">
              <!-- <el-image></el-image> -->
              <el-image :src="logoSrc"></el-image>
              <div style="display:flex;flex-direction:column;line-height:25px;padding: 20px 0px;">
                <h2>视频资源数据展示应用平台</h2>
                <div>http://spzspt.cflac.org.cn</div>
              </div>
            </el-col>
            <el-col :span="8" class="tl">
              <i class="nav_line"></i>
              <el-image
                style="width:18px;height:18px;vertical-align:middle;display:inline-block;"
                :src="homeSrc"
              ></el-image>
              <router-link style="vertical-align:middle;" to="/">首页</router-link>
              <!-- <div class="ss">
                文艺类视频
                <div class="v_type">
                  <ul>
                    <li v-for="item in typeList" :key="item.id">
                      <a href="/videolist2#nav_bread">{{item.title}}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <router-link to="/">素材类视频</router-link>-->
              <!-- <router-link to="/videolist">视频专题</router-link> -->
            </el-col>
            <el-col :span="8" class="tr">
              <el-image
                v-if="userName"
                style="width:22px;height:22px;vertical-align:middle;"
                :src="logoSrc"
              ></el-image>
              <span v-if="userName" style="vertical-align:middle;">{{userName}}</span>
              <!-- <el-dropdown style="height:50px;color:#fff;">
                <span class="el-dropdown-link">
                  个人中心
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click="logout">退出登录</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>-->
              <!-- <router-link to="/personalinfo">个人中心</router-link> -->

              <el-button v-if="userName" size="mini" type="primary" plain @click="logout">退出登录</el-button>
              <router-link to="/login" v-else>未登录，请先登录</router-link>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 主体显示 -->
      <div>
        <router-view></router-view>
      </div>
      <!-- 底部 -->
      <div class="nav_footer">
        <Foot />
      </div>
    </template>
  </div>
</template>

<script>
import Foot from '../components/footer/footer.vue'
import common from '../utils/common.utils'
import MFooter from '../components/footer/mfooter'
export default {
  components: {
    Foot,
    MFooter
  },
  data: function () {
    return {
      userName: '',
      isShow: false,
      typeList: [],
      logoSrc: require('../assets/img/logo2.png'),
      homeSrc: require('../assets/img/home.png')
    }
  },
  methods: {
    // 获取文艺类视频的二级分类
    getTypeList: async function () {
      var res = await this.$http.get('/v1/index/videoTypeList')
      var { code, data } = res.data
      if (code == 0) {
        this.typeList = data
      }
    },
    logout: function () {
      var that = this
      that
        .$confirm('确定退出登录？并跳转到登录页', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
        .then(async function () {
          var res = await that.$http.post(`/v1/bqUser/logout`)
          var { code, message, data } = res.data
          if (code == 0) {
            that.$message.success('退出登录')
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('userInfo')
            that.$store.state.userInfo = {}
            that.$router.push('/login')
          } else if (code == 40100) {
            that.$router.push('/login')
            that.$message({
              message: '未登录，即将跳转登录页',
              type: 'error',
              duration: '2000'
            })
          } else if (code == '40101') {
            that.$router.push('/login')
            that.$message({
              message: '登录已过期，即将跳转登录页',
              type: 'error',
              duration: '2000'
            })
          } else {
            that.$message.error(message)
          }
        })
        .catch(() => {})
    }
  },
  mounted: function () {
    if (window.localStorage.getItem('token')) {
      console.log('已登录')
      this.userName = window.localStorage.getItem('userName')
    } else {
      this.$store.state.userInfo = {}
      this.userName = ''
    }
    // alert(555);
    document.querySelector('#app').scrollIntoView(true)
    this.getTypeList()
    this.isShow = common._isMobile()
    // console.log(this.isShow);
  }
}
</script>

<style lang="scss" scoped>
// 头部
.nav_header {
  width: 100%;
  height: 80px;
  line-height: 80px;
  // margin-bottom: 40px;
  // background-color: #5cb6e4;
  background-color: #00aaff;
  color: #fff;
  a {
    color: #fff;
  }
}
.el-row {
  height: 100%;
  .el-col {
    height: 100%;
  }
}
.nav_footer {
  // position: relative;
  // bottom: 0px;
  padding-top: 160px;
  width: 100%;
}
// pc端
// 头部导航栏
.nav_header .header_txt {
  margin: 0 auto;
  width: 1200px;
  height: 100%;
  .nav-left {
    display: flex;
    flex-direction: row;
    .el-image {
      width: 42px;
      height: 42px;
      vertical-align: middle;
      margin-top: 20px;
      margin-right: 10px;
    }
  }
  .nav_line {
    display: inline-block;
    width: 1px;
    height: 50px;
    // margin-top: 15px;
    margin-right: 20px;
    background-color: #80d4ff;
    vertical-align: middle;
  }
  .tl {
    text-align: left;
    a {
      margin-right: 20px;
    }
  }
  .ss {
    position: relative;
    display: inline-block;
    width: 30%;
    text-align: center;
    &:hover {
      cursor: pointer;
      color: red;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      background-color: #f5f5f5;
      .v_type {
        display: block;
      }
    }
  }
  .tr {
    text-align: right;
    span {
      margin-right: 20px;
    }
  }
}
// 二级分类
.v_type {
  position: absolute;
  min-width: 400px;
  background-color: #f5f5f5;
  border-radius: 5px;
  box-shadow: 2px 2px 3px #409eff;

  padding: 15px 10px;
  left: 0px;
  display: none;
  z-index: 999;
  // border: 1px solid #fff;
  li {
    float: left;
    width: auto;
    margin-right: 10px;
    height: 40px;
    line-height: 40px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:hover {
      a {
        color: red;
      }
    }
    a {
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/nav.vue